import styled from "styled-components";

export const RequiredSymb = styled.span`
  color: red;
`;
